import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", form);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-sand px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-3xl border border-ink/10 bg-white p-8 shadow-lift"
        data-testid="admin-login-form"
      >
        <div className="mb-8 text-center">
          <img src="/assets/logo-circle.png" alt="The Birth Life" className="mx-auto h-14 w-14 rounded-full" />
          <h1 className="mt-4 font-display text-2xl font-semibold text-ink">Admin Dashboard</h1>
          <p className="mt-1 text-sm text-faint">The Birth Life · content management</p>
        </div>
        <input
          data-testid="admin-login-email"
          type="email"
          required
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="mb-3 w-full rounded-xl border border-ink/15 px-4 py-3 text-sm outline-none focus:border-terra"
        />
        <input
          data-testid="admin-login-password"
          type="password"
          required
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="mb-5 w-full rounded-xl border border-ink/15 px-4 py-3 text-sm outline-none focus:border-terra"
        />
        <button
          data-testid="admin-login-submit"
          disabled={loading}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-ink py-3 font-outfit text-sm font-semibold text-sand transition-colors hover:bg-terra disabled:opacity-60"
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
}
